<template lang="pug">
.point-deduct
  .copy 积分抵扣
  .point
    .total 200积分
    .detail 100积分x2
</template>
<script>
export default {
  name: 'PointDeduct',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.point-deduct
  width: 100%
  display: flex
  justify-content: space-between
  align-items: flex-start
  .copy
    font-size: pxToRem(26)
    color: black
  .point
    display: flex
    align-items: flex-end
    flex-direction: column
    .total
      font-size: pxToRem(26)
      color: #ff6010
    .detail
      font-size: pxToRem(26)
      color: #cccccc
</style>
